import React, { useEffect, useMemo } from 'react';
import ReportRegisterTab from './ReportRegisterTab';
import ForbiddenAccess from '../ForrbiddenAccessComponent/ForbiddenAccess';
import { useParams } from 'react-router-dom';
import BackBtn from '../UI/BackBtn';
import Page from '../_layout/Page';
import useUserContext from '../../hooks/useUserContext';
import { hasPermsOnIndexesOrReceipts } from '../../services/rolesSvc';
import UnifiedSPTable from "./UnifiedSPTable";
import MilestonesTable from '../project/Widgets/Milestones/MilestonesTable';
import useNavProject from '../../hooks/useNavProject';
import useAPI from '../../hooks/useAPI';
import Receipts from '../../components/table/Receipts';

export default function SPReportWidgetsWithPage(){
  const { type } = useParams();
  const userCtx = useUserContext()
  const {stratId} = useParams()
  const navProject = useNavProject()
  const api = useAPI()

  useEffect(async() => {
    const stratProj = await api.get(`/mng/strategies/${stratId}`)
    navProject.setStratNumber(stratProj.id)
    navProject.setStratTitle(stratProj.name)
  }, [])


  const content = useMemo(() => [
    { type: 'reports', header: 'Реестр отчетов', content: <ReportRegisterTab /> },
    { type: 'unified', content: <UnifiedSPTable hasChildData={false}/>, show: () => hasPermsOnIndexesOrReceipts(userCtx, {stratId}) },
    { type: 'milestones', content: <MilestonesTable/> },
    { 
      type: 'receipts', 
      content: 
        <Receipts 
          stratId={stratId}
          tableLeftValues={[224, 454]}
          type={'strategyProjectReceipts'}
          totalIndex={2}
        />
    }
  ], [userCtx]);
  return (
    <Page style={{ padding: '2.5em 3em' }}>
      <BackBtn/>
      {content.filter((x) => x.type === type)[0]?.header
        && <div className="project-title-wrapper" style={{ paddingBottom: '0', color: '#0C0065' }}>
          <h2>{content.filter((x) => x.type === type)[0]?.header}</h2>
      </div>}
      {content.filter((x) => x.type === type)[0].content || <ForbiddenAccess />}
    </Page>
  )
}
